import React, { type FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import IconButtonLink from '@dashboard/components/mui-atoms/IconButtonLink';
import { alertError } from '@dashboard/contexts/SnackbarManager/store';
import buildError from '@dashboard/errors';
import { useCreatePlatformMutation } from '@dashboard/generated/wp/authentication';
import { ArrowBackOutlined } from '@mui/icons-material';
import { Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';

export default function PlatformNewPage(): JsxNode {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [mutation, { loading }] = useCreatePlatformMutation();

  async function onSubmit(ev: FormEvent<HTMLFormElement>) {
    ev.preventDefault();
    try {
      const { data } = await mutation({ variables: { name, description } });
      const id = data?.createPlatform?.id;
      if (id) {
        navigate(`/o/${id}`);
      }
    } catch (e) {
      const error = buildError(e);
      alertError(error.message);
    }
  }

  return (
    <Grid container justifyContent="center" sx={{ my: { xs: 1, md: 3 } }}>
      <Grid item xs={12} md={10} lg={8} xl={7}>
        <Paper sx={{ p: 3 }}>
          <Stack spacing={2}>
            <IconButtonLink href="/" edge="start">
              <ArrowBackOutlined />
            </IconButtonLink>
            <Typography variant="h3" component="h1">
              Create workspace
            </Typography>
            <form onSubmit={onSubmit}>
              <TextField
                margin="normal"
                label="Name"
                autoFocus
                value={name}
                onChange={(ev) => setName(ev.target.value)}
                fullWidth
                required
              />
              <TextField
                margin="normal"
                label="Description"
                value={description}
                onChange={(ev) => setDescription(ev.target.value)}
                fullWidth
                inputProps={{
                  maxLength: 100,
                }}
              />
              <Box mt={5}>
                <Button disabled={loading} type="submit" variant="contained">
                  Create
                </Button>
              </Box>
            </form>
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  );
}
